import { render, staticRenderFns } from "./EmployeeMappingForCompensatory.vue?vue&type=template&id=93351c0a"
import script from "./EmployeeMappingForCompensatory.vue?vue&type=script&lang=js"
export * from "./EmployeeMappingForCompensatory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports